import { render, staticRenderFns } from "./CaratulaMge.vue?vue&type=template&id=6d81be26&scoped=true&"
import script from "./CaratulaMge.vue?vue&type=script&lang=js&"
export * from "./CaratulaMge.vue?vue&type=script&lang=js&"
import style0 from "./CaratulaMge.vue?vue&type=style&index=0&id=6d81be26&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d81be26",
  null
  
)

export default component.exports